<template>
	<div class="bg-gray-500 h-full">
		<h1>Login</h1>
	</div>
</template>

<script>
export default {
	name: 'Login',
	components: {}
}
</script>
